import { Action } from '@ngrx/store';
import { datosModelo } from 'src/app/models/SicarMap/datosModelo.model';

export const VISIBLE_PANELMPS = '[PANEL_MPS] Visible';
export const HIDDEN_PANELMPS = '[PANEL_MPS] HIDDEN';


export class VisibleMPSAction implements Action {
  readonly type = VISIBLE_PANELMPS;
  constructor(public ConfModelo: datosModelo) {}
}

export class HiddenMPSAction implements Action {
  readonly type = HIDDEN_PANELMPS;
  constructor() {}
}

export type MPSActions =
  | VisibleMPSAction
  | HiddenMPSAction;
